import { render } from "./ShipmentLabel.vue?vue&type=template&id=fb8d63ce&scoped=true"
import script from "./ShipmentLabel.vue?vue&type=script&lang=js"
export * from "./ShipmentLabel.vue?vue&type=script&lang=js"

import "./ShipmentLabel.vue?vue&type=style&index=0&id=fb8d63ce&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8d63ce"]])

export default __exports__